(function () {
  if (window.__lxryLazy) return;
  window.__lxryLazy = true;
  function load(img) {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.sizes) img.sizes = img.dataset.sizes;
    if (img.dataset.src) img.src = img.dataset.src;
    img.removeAttribute('data-lxry-lazy');
  }
  function init() {
    var imgs = document.querySelectorAll('img[data-lxry-lazy]');
    if (!('IntersectionObserver' in window)) {
      imgs.forEach(load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          io.unobserve(e.target);
          load(e.target);
        }
      });
    }, { rootMargin: '300px 0px' });
    imgs.forEach(function (i) { io.observe(i); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
